export const environment = {
  production: true,
  //apiUrl: 'http://localhost:5168', // your API URL for development http://localhost:5276/ 'https://api.realdesk.ing:5001',//
  apiUrl: 'https://api.realdesk.net:5001',
  websocketUrl: 'wss://41t8ude7pj.execute-api.us-east-1.amazonaws.com/production/',
  websocketClientUrl: 'wss://u6u6m9i7tl.execute-api.us-east-1.amazonaws.com/production/',
  websocketClientUrlzap: 'wss://etnxlqy6p0.execute-api.us-east-1.amazonaws.com/production/'
};